import store from "redux/store";

const initialState = {
	open: false,
	data: null,
	timeout: null
};

const revenuePopupReducer = (state = initialState, action) => {
	switch (action.type) {
		case "REVENUE_POPUP_OPEN":
			state.timeout && clearTimeout(state.timeout);
			const newTimeout = setTimeout(() => store.dispatch({ type: "REVENUE_POPUP_CLOSE" }), 10000);
			return { ...state, open: true, timeout: newTimeout };
		case "REVENUE_POPUP_CLOSE":
			return { ...state, open: false, timeout: null };
		case "SET_REVENUE_POPUP_DATA":
			return { ...state, data: action.payload };
		default:
			return state;
	}
};

export default revenuePopupReducer;
